// WARNING: if you do "organize imports", make sure that this remains on top of the file!
import "./apollo-gen-crud/entitiesGen";

import { Messages } from "@crispico/foundation-gwt-js";
import { AppMeta, CompMeta, ConnectedPageHelper, EntityDescriptor, FoundationInitializationsForClient, searchOptions, Utils, Optional, Organization, MenuEntry, User, ENT_TABLE, ENT_READ, AppContainer, OrganizationFilter } from '@crispico/foundation-react';
import { AppMetaTempGlobals } from "@crispico/foundation-react/AppMetaTempGlobals";
import { infoTemplateConnectedComponent } from '@crispico/foundation-react/demo/pages/_TemplateConnectedComponent/TemplateConnectedComponent';
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";
import { dashboardEntityDescriptor } from "@crispico/foundation-react/FoundationEntityDescriptors";
import { auditEntityDescriptor } from "@crispico/foundation-react/pages/Audit/auditEntityDescriptor";
import * as dashboardZt from "@crispico/foundation-react/pages/dashboard/dashboardTab/stories";
import { DashboardWidgetEntityDescriptor, DashboardWidgetFactories, DashboardWidgetFactory, DashboardWidgetType } from "@crispico/foundation-react/pages/dashboard/DashboardWidgetFactory";
import { entityToTagEntityDescriptor, tagEntityDescriptor } from '@crispico/foundation-react/pages/EntityToTag/entityToTagDescriptor';
import { HomePage, infoHomePage } from '@crispico/foundation-react/pages/HomePage';
import { infoLoginPage } from "@crispico/foundation-react/pages/loginPage/LoginPage";
import { notificationEntityDescriptor, problemEntityDescriptor } from "@crispico/foundation-react/pages/notification/notificationEntityDescriptor";
import { infoPasswordResetFinishPage } from "@crispico/foundation-react/pages/passwordReset/PasswordResetFinishPage";
import { infoPasswordResetInitPage } from "@crispico/foundation-react/pages/passwordReset/PasswordResetInitPage";
import { infoPersonalHomePage } from "@crispico/foundation-react/pages/PersonalHomePage";
import { roleEntityDescriptor, roleToUserEntityDescriptor } from "@crispico/foundation-react/pages/role/roleEntityDescriptor";
import * as roleZt from '@crispico/foundation-react/pages/role/stories';
import { scheduledTaskEntityDescriptor } from "@crispico/foundation-react/pages/ScheduledTasks/ScheduledTaskEntityDescriptor";
import { organizationEntityDescriptor, settingsEntityDescriptor } from '@crispico/foundation-react/pages/SettingsEntity/settingsEntityDescriptor';
import { zeroTrainingIndexPageMenuEntry } from '@crispico/foundation-react/zeroTraining/ZeroTrainingIndexPage';
import { addressEntityDescriptor, AppEntityDescriptors, blocklyScriptEntityDescriptor, humanResourceEntityDescriptor, qualificationEntityDescriptor, flightEntityDescriptor, missionEntityDescriptor, baggageEntityDescriptor, chartEntityDescriptor, ganttAssignmentEntityDescriptor, taskEntityDescriptor, detectionEventEntityDescriptor, ganttAssignmentParamsEntityDescriptor } from "AppEntityDescriptors";
import { MapWidgetRRC } from "components/editorWidgets";
import { MARKER_TYPE } from "components/MapContainerLeaflet/MapContainerLeaflet";
import { CLUSTER_MODE, MAP_CLUSTER_MODE_KEY } from "components/realTimeMap/RealTimeMap";
import { VehicleInformationWidget } from "components/VehicleInformationWidget";
import { push } from "connected-react-router";
import 'font-awesome/css/font-awesome.min.css';
import { checklistEntityDescriptor } from 'pages/Checklist/checklistEntityDescriptor';
import { drivingEventEntityDescriptor } from "pages/DrivingEvent/drivingEventEntityDescriptor";
import { equipmentResourceEntityDescriptor } from 'pages/EquipmentResource/equipmentResourceEntityDescriptor';
import { flightScheduleEntityDescriptor } from "pages/flightSchedule/flightScheduleEntityDescriptor";
import { historicalMapAnalysisEntityDescriptor } from 'pages/HistoricalMapAnalysis/historicalMapAnalysisEntityDescriptor';
import { inventoryHistoryDataEntityDescriptor } from 'pages/InventoryPage/inventoryHistoryDataEntityDescriptor';
import { positionEntityDescriptor } from "pages/Position/positionEntityDescriptor";
import { infoScanBaggageFormPage } from "pages/ScanBaggage/ScanBaggageFormPage";
import { territoryEntityDescriptor } from 'pages/Territory/territoryEntityDescriptor';
import "pages/XopsPersonalHomePage";
import React, { RefObject } from 'react';
import { NavLink } from "react-router-dom";
import { Card, Checkbox, Icon, Menu, SemanticCOLORS } from 'semantic-ui-react';

// WARNING: if you do "organize imports", make sure this is remains at the bottom so that the styles are applied.
import 'xops6.css';
import { WidgetProps } from "@crispico/foundation-react/pages/dashboard/dashboardTab/WidgetWrapper";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { XopsLoginPage } from "pages/XopsLoginPage";
import { xopsMobileWrapperBackboneRoutes, xopsMobileWrapperPageUrlPageMenuEntry, xopsMobileWrapperBackbonePublicRoutes, w, xopsMobileWrapperSettingsMenuEntry, XopsMobileWrapper, XOPS_MOBILE_PATH, XOPS_MOBILE_MISSIONS_PATH } from "pages/XopsMobile/XopsMobileWrapper";
import { missionsAwaitingForDriversPageRoute, missionsAwaitingForDriversPageMenuEntry } from "pages/Mission2/Mission2EntityDescriptor";
import { DiagnosticTroubleCodeWidgetRRC } from "pages/EquipmentResource/DiagnosticTroubleCodeWidget";
import { WidgetStatus } from "@crispico/foundation-react/pages/dashboard/AbstractWidgetWithFilter";
import { fileBrowserPageMenuEntry, fileBrowserPageRoute } from "@crispico/foundation-react/pages/FileBrowser/FileBrowserPage";
import { ganttAssignmentFromFilesOnDiskPageMenuEntry, ganttAssignmentFromFilesOnDiskPageRoute } from "pages/ganttAssignment/GanttAssignmentFromFilesOnDiskPage";
import { GanttAssignmentEntityDescriptor } from "pages/ganttAssignment/GanttAssignmentEntityDescriptor";
import { EntityFilterMode } from "@crispico/foundation-react/entity_crud/fieldEditors/FilterFieldEditor";
import { mobileDeviceEntityDescriptor } from "pages/MobileDevice/mobileDeviceEntityDescriptor";
import { bluetoothDevicesPageMenuEntry, bluetoothDevicesPageRoute } from "pages/BluetoothDevices/BluetoothDevicesPage";
import { realTimeGanttPageMenuEntry, realTimeGanttPageRoute } from "pages/gantt/RealTimeGanttPage";
import { HistoryGraphItemFactory } from "@crispico/foundation-react/pages/Audit/historyGraphItem/HistoryGraphItemFactory";
import { HistoryGraphMapItemRRC } from "pages/EquipmentResource/HistoryGraphMapItem";
import { assignTasksToResourcePageFlexRoute, assignTasksToResourcePageMenuEntry, assignTasksToResourcePageRoute } from "pages/gantt/AssignTasksToResourcePage";
import { RRC_SINGLETON } from "@crispico/foundation-react/reduxReusableComponents/ReduxReusableComponents";
import { XopsColorRegistry, XopsColorRegistryRRC } from "pages/XopsColor/XopsColorRegistry";
import { missionEventValidationPageMenuEntry, missionEventValidationPageRoute } from "pages/Mission2/MissionEventValidationPage";
import { AssociationStringFieldEditorFieldDescriptor } from "components/AssociationStringFieldEditor";
import { DashboardTab } from "@crispico/foundation-react/pages/dashboard/dashboardTab/DashboardTab";
import { RealTimeMapWidget } from "components/RealTimeMapWidget";
import { ResponsiveMode } from "@crispico/foundation-react/AppContainerContext";
import { HistoryGraphMissionGanttItemRRC } from "pages/Mission2/HistoryGraphMissionGanttItem";
import { realTimeFlightEquipmentResourcePageMenuEntry, realTimeFlightEquipmentResourcePageUrlRoute } from "pages/gantt/pages/RealTimeFlightEquipmentResourcePage";
import { realTimeFlightHumanResourceSchedulePageMenuEntry, realTimeFlightHumanResourceSchedulePageUrlRoute } from "pages/gantt/pages/RealTimeFlightHumanResourceSchedulePage";
import { contextMenuActions } from "components/ContextMenuRegistry";
import { EditAction } from "actions/EditAction";
import { DeleteAction } from "actions/DeleteAction";
import { CreateMissionAction } from "actions/CreateMissionAction";
import { QueryOptions } from "apollo-client";
import { OpenClosedAndOverdueMissions } from "actions/OpenClosedAndOverdueMissions";
import { CreateTaskAction } from "actions/CreateTaskAction";
import { ReportDescriptorMaterializers } from "@crispico/foundation-react/backgroundTask/ReportDescriptorMaterializers";

let userEntityDescriptor: EntityDescriptor;
import("@crispico/foundation-react/pages/user/userEntityDescriptor").then(p => {
    userEntityDescriptor = p.userEntityDescriptor;
    userEntityDescriptor.addFieldDescriptor({ name: "units", type: FieldType.string }, AssociationStringFieldEditorFieldDescriptor("Unit"));
    userEntityDescriptor.addFieldDescriptor({ name: "screen", type: "Perspective" });
    userEntityDescriptor.addFieldDescriptor({ name: "roles", type: FieldType.oneToMany("XopsRole") });
});

const mailto = 'mailto:xops@resonate-mp4.com?subject=' + _msg('Menu.ticket.email.title') + '&body=' + encodeURIComponent(_msg('Menu.ticket.email.body'))

ConnectedPageHelper.tempEnableSecurity = true;
Utils.DEFAULT_TEXT_COLOR = '#3A527B'; // same as the one from xops6.css (blue color)

const ELA_RFID_ANTENNA_FULL: string = "ELA_RFID_ANTENNA_FULL";
export const VIDEO_SHOW_PAGE: string = "VIDEO_SHOW_PAGE";
export const VIDEO_ALLOW_VIEW_BLURRED: string = "VIDEO_ALLOW_VIEW_BLURRED";
export const VIDEO_ALLOW_VIEW_ORIGINAL: string = "VIDEO_ALLOW_VIEW_ORIGINAL";
export const VIDEO_ALLOW_LIVE_FEED: string = "VIDEO_ALLOW_LIVE_FEED";
export const GANTT_EQUIPMENT_RESOURCE_SHOW_PAGE: string = "GANTT_EQUIPMENT_RESOURCE_SHOW_PAGE";
export const GANTT_HUMAN_RESOURCE_SCHEDULE_SHOW_PAGE: string = "GANTT_HUMAN_RESOURCE_SCHEDULE_SHOW_PAGE";
export const MISSIONS_AWAITING_FOR_DRIVER_SHOW_PAGE: string = "MISSIONS_AWAITING_FOR_DRIVER_SHOW_PAGE";

/**
 * Used to set dummy strings to InitializationsForClient so we can work with AppMeta routes even if 
 * we don't have them yet (needed for XopsMobile).
 */
const DUMMY_STRING: string = 'DUMMY';
export interface MapFields {
    name: string,
    fields: string
}

export interface MarkerSettings {
    markerIdField: string,
    markerType: string,
    showTextUnderIcon: boolean,
    colors: {
        name: string;
        area: string;
        field: string;
        showInFilterBar: string;
        useDurationBetweenNowAndFieldValue: boolean;
        intervals: {
            label?: string;
            from: string;
            to?: string;
            color: string;
        }[];
    }[]
    bigPopupFields: MapFields[]
    smallPopupFields: MapFields[]
    rowFields: MapFields[]
}

export interface MapSettings {
    airport: string,
    bingAPIKey?: string,
    azureMapsAPIKey?: string,
    markers: MarkerSettings[],
    goToButtonEntityTypes?: string,
}

export interface ConveyorEjectSettings {
    conveyorEject: string,
    color?: string,
    parkings: [{ id: number }]
}
export interface TempUnitSettings {
    organizationId?: number,
    missionTypesToDisplay?: [{ id: number }],
    defaultTripTimeToParking?: number;
    defaultLCOffset?: number;
    defaultMCOffset?: number;
    defaultSCOffset?: number;
}

export interface BaggageStatusSettings {
    name: string,
    label: string,
    color: SemanticCOLORS,
    displayMode: number
}

export enum MissionsAwaitingForDriversPageRendererMode {
    DEFAULT = "DEFAULT",
    BAGGAGE_LAST_MINUTE = "BAGGAGE_LAST_MINUTE"
}
export interface TempMissionTypeSettings {
    missionType: number,
    startAddresses?: [{ id: number }],
    missionsAwaitingForDriversPageRendererMode: MissionsAwaitingForDriversPageRendererMode,
    setObjectEndAddressFromFlightConnectionParking?: boolean,
    initialStatus?: string
}
export interface TempSettingsXops {
    tempUnitSettings: TempUnitSettings[],
    tempFlightConveyorEjectSettings: ConveyorEjectSettings[],
    tempBaggageStatusSettings: BaggageStatusSettings[],
    tempMissionTypeSettings: TempMissionTypeSettings[],
    displayForSas: boolean
}

export interface FlightSettings {
    rotationFlightOffset: number,
    findByStringFlightDateOffsetHours: number
}

export interface BlurImplementationSettings {
    id: string;
}

export interface BlurSettings {
    implementations: BlurImplementationSettings[],
    activeImplementationId: string
}

export interface EquipmentResourceProposedTimeSlot {
    equipmentTypeId: number,
    minRequiredTimeBetweenMissions: number,
    offset: number,
    duration: number,
    createMissionOfType: number,
    missionType: { id: number, name: string, color: number },
    createMissionOfInactivityType: number,
    inactivityType: { id: number, name: string, color: string, duration: number },
    importance: number
}

export interface EquipmentResourceSettings {
    proposedTimeSlots: EquipmentResourceProposedTimeSlot[];
}

export interface UserMenuSettings {
    showChangeEquipment: boolean;
}

export interface XopsInitializationsForClient extends FoundationInitializationsForClient {
    mapSettings: MapSettings,
    tempSettingsXops: TempSettingsXops,
    flightSettings: FlightSettings,
    currentHumanResource: any /* this should have a type*/,
    hasLongStorage: boolean,
    alvestAuthenticationEnabled: boolean, // only for LINK
    blurSettings: Optional<BlurSettings>, // only admins have this settings
    mission2Settings: Mission2Settings,
    equipmentResourceSettings: EquipmentResourceSettings,
    userMenuSettings: UserMenuSettings
}

export interface Mission2Settings {
    allowNoEquipment?: boolean,
    missionItemRenderers: MissionItemRendererSettings[],
}

export interface MissionItemRendererSettings {
    missionType?: number,
    circleColor?: string,
    backgroundColor?: string
}

export class XopsAppMeta extends AppMeta {

    constructor(public metas: CompMeta<any, any>[]) {
        super(metas);

        this.globalPermissions.add(ELA_RFID_ANTENNA_FULL);
        this.globalPermissions.add(VIDEO_SHOW_PAGE);
        this.globalPermissions.add(VIDEO_ALLOW_VIEW_BLURRED);
        this.globalPermissions.add(VIDEO_ALLOW_VIEW_ORIGINAL);
        this.globalPermissions.add(VIDEO_ALLOW_LIVE_FEED);
        this.globalPermissions.add(GANTT_EQUIPMENT_RESOURCE_SHOW_PAGE);
        this.globalPermissions.add(GANTT_HUMAN_RESOURCE_SCHEDULE_SHOW_PAGE);
        this.globalPermissions.add(MISSIONS_AWAITING_FOR_DRIVER_SHOW_PAGE);

        this.routes.push(...xopsMobileWrapperBackboneRoutes());
        this.routes.push(...xopsMobileWrapperBackbonePublicRoutes());
        this.routes.push(missionsAwaitingForDriversPageRoute());
        this.routes.push(fileBrowserPageRoute());
        this.routes.push(bluetoothDevicesPageRoute());
        this.routes.push(ganttAssignmentFromFilesOnDiskPageRoute());
        this.routes.push(realTimeGanttPageRoute());
        this.routes.push(realTimeFlightEquipmentResourcePageUrlRoute());
        this.routes.push(realTimeFlightHumanResourceSchedulePageUrlRoute());
        this.routes.push(assignTasksToResourcePageRoute());
        this.routes.push(missionEventValidationPageRoute());
        this.routes.push(assignTasksToResourcePageFlexRoute());
        this.routes.push(scheduledTaskEntityDescriptor.renderTableRoute());
    }

    showOrganizationDropdownItem(): boolean {
        if (isFlexMode()) {
            return false;
        }
        return super.showOrganizationDropdownItem();
    }

    showHomeButton(): boolean {
        if (XopsMobileWrapper.isDeviceMobileApp() || XopsMobileWrapper.isDeviceWindowsApp()) {
            return false;
        }
        return super.showHomeButton();
    }

    protected hasHomePageMenuEntry() {
        return !XopsMobileWrapper.isDeviceMobileApp() && !XopsMobileWrapper.isDeviceWindowsApp();
    }

    canCallOnLocationChangedFromAppContainerConstructor(): boolean {
        return !XopsMobileWrapper.isDeviceMobileApp() && !XopsMobileWrapper.isDeviceWindowsApp();
    }

    public getIsSpecialPageWithoutHeader() {
        let displayForSas = this.getDisplayForSas();
        return super.getIsSpecialPageWithoutHeader() || isFlexMode() || (isIframe() && displayForSas);
    }

    protected async invokeGetInitializationsForClientQuery(options: QueryOptions) {
        const { data, ...rest } = await super.invokeGetInitializationsForClientQuery(options);

        const initializationsForClient = data?.clientInitializationService_initializationsForClient;
        const organizationSettings = initializationsForClient?.organizationSettings;

        if (isFlexMode() && organizationSettings) {
            // disable Left Organization Tree in flex mode
            return {
                ...rest,
                data: {
                    ...data,
                    clientInitializationService_initializationsForClient: {
                        ...initializationsForClient,
                        organizationSettings: {
                            ...organizationSettings,
                            globalOrganizationFilter: OrganizationFilter.NONE
                        }
                    }
                }
            };
        }
        return { ...rest, data };
    }

    public async loadInitializationsForClient_forMobile() {
        await super.loadInitializationsForClient_fromConstructor();
    }

    protected async loadInitializationsForClient_fromConstructor() {
        if (XopsMobileWrapper.isDeviceMobileApp() || XopsMobileWrapper.isDeviceWindowsApp()) {
            // this was used because in this moment helperAppContainer wasn't initialized yet;
            // need to find another way to do it
            setTimeout(async () => {
                console.log("isMobileApp / isWindowsApp, set default props!");
                this.helperAppContainer.dispatchers.setInReduxState({
                    initializationsForClientLoaded: true,
                    appContainerContextValue: {
                        initializationsForClient: {
                            currentOrganization: undefined,
                            currentOrganizationDropdownValue: undefined,
                            /* TODO RM35832: temp fix until integrate the foundation fix, can use undefined after integration and new version of foundation */
                            currentUser: null,
                            currentPermissions: undefined,
                            currentRole: undefined,
                            allOrganizationsAccess: undefined,
                            ldapAvailable: false,
                            version: DUMMY_STRING,
                            visualStyleSettings: {},
                            homePageSettings: { usePersonalHomePage: false, homePageDashboards: [{ id: 0 }], footerBarText: "", defaultPage: "", defaultPageMobile: "" },
                            colorSettings: { data: [] },
                            internationalizationSettings: { showBothOriginalAndTranslated: false, translatableByUserLanguagesMap: {}, defaultLanguage: "en" },
                            fileBrowserBulkDownloadMaximumFileSize: 0,
                            mapSettings: { airport: DUMMY_STRING, markers: [] },
                            flightSettings: { rotationFlightOffset: 0, findByStringFlightDateOffsetHours: 0 },
                            tempSettingsXops: { tempUnitSettings: [], tempBaggageStatusSettings: [], tempFlightConveyorEjectSettings: [], tempMissionTypeSettings: [], displayForSas: false },
                            currentHumanResource: undefined,
                            hasLongStorage: false,
                            alvestAuthenticationEnabled: false,
                            blurSettings: undefined,
                            mission2Settings: {} as Mission2Settings,
                            equipmentResourceSettings: {} as EquipmentResourceSettings,
                            userMenuSettings: {} as UserMenuSettings
                        } as XopsInitializationsForClient,
                        responsiveState: { mode: ResponsiveMode.MOBILE }
                    }
                });
                console.log("isMobileApp / isWindowsApp, init mobile app and go to xops-mobile!");
                XopsMobileWrapper.init();
            }, 100);
            return;
        } else {
            XopsMobileWrapper.init();
        }
        super.loadInitializationsForClient_fromConstructor();
    }

    finalizeEntityDescriptors() {
        this.addEntityDescriptors([
            organizationEntityDescriptor, userEntityDescriptor, roleEntityDescriptor, roleToUserEntityDescriptor,
            settingsEntityDescriptor,
            checklistEntityDescriptor,
            chartEntityDescriptor,
            equipmentResourceEntityDescriptor,
            historicalMapAnalysisEntityDescriptor,
            territoryEntityDescriptor,
            entityToTagEntityDescriptor,
            tagEntityDescriptor,
            positionEntityDescriptor,
            inventoryHistoryDataEntityDescriptor,
            auditEntityDescriptor,
            drivingEventEntityDescriptor,
            flightScheduleEntityDescriptor,
            notificationEntityDescriptor,
            problemEntityDescriptor,
            detectionEventEntityDescriptor,
            mobileDeviceEntityDescriptor
        ]);
        new AppEntityDescriptors().init();
        return super.finalizeEntityDescriptors();
    }

    protected getFieldsForInitializationsForClient() {
        return `currentUser { id firstName lastName username isAdmin language } flightSettings { rotationFlightOffset findByStringFlightDateOffsetHours }
                mapSettings { azureMapsAPIKey bingAPIKey airport markers { markerIdField markerType showTextUnderIcon colors { name area field showInFilterBar useDurationBetweenNowAndFieldValue intervals { label from to color } } bigPopupFields { name fields } smallPopupFields { name fields } rowFields { name fields } }  goToButtonEntityTypes }
                tempSettingsXops { displayForSas tempUnitSettings { organizationId missionTypesToDisplay { id } defaultTripTimeToParking defaultLCOffset defaultMCOffset defaultSCOffset } tempFlightConveyorEjectSettings { conveyorEject color parkings { id } } tempBaggageStatusSettings { name label color displayMode } tempMissionTypeSettings { missionType startAddresses { id } setObjectEndAddressFromFlightConnectionParking missionsAwaitingForDriversPageRendererMode initialStatus } }
                currentHumanResource { id identifier firstName lastName pdaIdentifier unit { id name telephone } mobileDeviceId mobileDevice { id identifier } vehicle { id identifier initBusParking { name } } currentQualifications { qualificationType { id name } startDate endDate }  }
                hasLongStorage alvestAuthenticationEnabled
                blurSettings { implementations { id } activeImplementationId }
                mission2Settings { missionItemRenderers { missionType circleColor backgroundColor } allowNoEquipment }
                equipmentResourceSettings { proposedTimeSlots { equipmentTypeId minRequiredTimeBetweenMissions offset duration createMissionOfType missionType { id name color } createMissionOfInactivityType inactivityType { id name color } importance } }
                userMenuSettings { showChangeEquipment }
                `
            + super.getFieldsForInitializationsForClient();
    }

    getDisplayForSas(): boolean {
        const { tempSettingsXops } = (this.helperAppContainer.dispatchers.getState().appContainerContextValue.initializationsForClient as XopsInitializationsForClient);
        return tempSettingsXops.displayForSas;
    }

    protected resetMenuEntries() {
        super.resetMenuEntries();
        Messages.getInstance().setLanguage("en");
    }

    getUIEntityDescriptors(): { [entityName: string]: EntityDescriptor } {
        let firstTime = false;
        if (this.uiEntityDescriptors === undefined) {
            firstTime = true;
        }
        super.getUIEntityDescriptors();

        if (firstTime && this.uiEntityDescriptors) {
            delete this.uiEntityDescriptors["Leave"];
            delete this.uiEntityDescriptors["LeaveType"];
            delete this.uiEntityDescriptors["Employee"];
            delete this.uiEntityDescriptors["Department"];
            delete this.uiEntityDescriptors["Job"];
        }
        return this.uiEntityDescriptors!;
    }

    createMenuEntries(data: FoundationInitializationsForClient, entityCrudMenus: any): any {
        const frequentyUsedMenu: any[] = [];

        const fmsMenu = [
            { content: _msg("MapRealTime"), to: equipmentResourceEntityDescriptor.getEntityTableUrl() + "/realTimeMap", icon: "map outline", permission: Utils.pipeJoin([ENT_TABLE, equipmentResourceEntityDescriptor.name]) },
            equipmentResourceEntityDescriptor.getMenuEntry(),
            humanResourceEntityDescriptor.getMenuEntry(),
            drivingEventEntityDescriptor.getMenuEntry(),
            detectionEventEntityDescriptor.getMenuEntry(),
            positionEntityDescriptor.getMenuEntry(),
            historicalMapAnalysisEntityDescriptor.getMenuEntry()
        ];

        let omsMenu = [
            xopsMobileWrapperPageUrlPageMenuEntry(),
            realTimeFlightHumanResourceSchedulePageMenuEntry(),
            flightEntityDescriptor.getMenuEntry(),
            taskEntityDescriptor.getMenuEntry(),
            missionEntityDescriptor.getMenuEntry(),
            ...(AppMetaTempGlobals.appMetaInstance.hasPermission(MISSIONS_AWAITING_FOR_DRIVER_SHOW_PAGE, false, data.currentPermissions) ? [missionsAwaitingForDriversPageMenuEntry()] : []),
            equipmentResourceEntityDescriptor.getMenuEntry(),
            humanResourceEntityDescriptor.getMenuEntry(),
            entityDescriptors["HumanResourceSchedule"].getMenuEntry(),
            mobileDeviceEntityDescriptor.getMenuEntry()
        ];
        if (XopsMobileWrapper.isDeviceMobileApp() || XopsMobileWrapper.isDeviceWindowsApp()) {
            omsMenu.push(xopsMobileWrapperSettingsMenuEntry());
        }

        const poolingMenu = [
            realTimeFlightEquipmentResourcePageMenuEntry(),
            equipmentResourceEntityDescriptor.getMenuEntry(),
            flightEntityDescriptor.getMenuEntry(),
            taskEntityDescriptor.getMenuEntry(),
            missionEntityDescriptor.getMenuEntry(),
            entityDescriptors["EquipmentType"].getMenuEntry(),
            entityDescriptors["TaskType"].getMenuEntry(),
            entityDescriptors["EquipmentTypeTask"].getMenuEntry(),
            entityDescriptors["EquipmentAuthorization"].getMenuEntry(),
            entityDescriptors["FlightAndObjectAction"].getMenuEntry(),
            ganttAssignmentEntityDescriptor.getMenuEntry(),
            ganttAssignmentParamsEntityDescriptor.getMenuEntry(),
        ]

        const referencedDataMenu = [
            {
                content: _msg("Menu.referenceData.common"), icon: "file alternate", submenus: [
                    organizationEntityDescriptor.getMenuEntry(),
                    addressEntityDescriptor.getMenuEntry(),
                    territoryEntityDescriptor.getMenuEntry(),
                    entityDescriptors["Airport"].getMenuEntry(),
                    tagEntityDescriptor.getMenuEntry(),
                    entityToTagEntityDescriptor.getMenuEntry(),
                    checklistEntityDescriptor.getMenuEntry()
                ]
            },
            {
                content: _msg("Menu.FMS"), icon: "file alternate", submenus: [
                    entityDescriptors["EquipmentModel"].getMenuEntry(),
                    entityDescriptors["EquipmentModelFamily"].getMenuEntry(),
                    entityDescriptors["EquipmentProductType"].getMenuEntry(),
                    entityDescriptors["EquipmentUsageLog"].getMenuEntry(),
                    entityDescriptors["TelemetrySystem"].getMenuEntry(),
                    entityDescriptors["TelemetryEventMapping"].getMenuEntry(),
                    entityDescriptors["DiagnosticTroubleCode"].getMenuEntry(),
                    entityDescriptors["Puck"].getMenuEntry()
                ]
            },
            {
                content: _msg("Menu.OMS"), icon: "file alternate", submenus: [
                    entityDescriptors["HumanResourceSchedule"].getMenuEntry(),
                    entityDescriptors["HumanResourceShift"].getMenuEntry(),
                    entityDescriptors["HumanResourceLog"].getMenuEntry(),
                    entityDescriptors["HumanResourceMessage"].getMenuEntry(),
                    entityDescriptors["QualificationType"].getMenuEntry(),
                    entityDescriptors["Qualification"].getMenuEntry(),

                    entityDescriptors["EquipmentType"].getMenuEntry(),
                    entityDescriptors["Radio"].getMenuEntry(),

                    baggageEntityDescriptor.getMenuEntry(),
                    entityDescriptors["InactivityType"].getMenuEntry(),

                    entityDescriptors["Airline"].getMenuEntry(),
                    entityDescriptors["PlaneType"].getMenuEntry(),
                    flightScheduleEntityDescriptor.getMenuEntry(),
                    entityDescriptors["FlightConnexion"].getMenuEntry(),
                    entityDescriptors["FlightAndObjectAction"].getMenuEntry(),
                    entityDescriptors["ValuesGroup"].getMenuEntry(),
                    entityDescriptors["TaskType"].getMenuEntry(),
                    entityDescriptors["Zone"].getMenuEntry(),
                    entityDescriptors["ZoneDistance"].getMenuEntry(),
                    entityDescriptors["CDGPortParking"].getMenuEntry(),
                    entityDescriptors["Pit"].getMenuEntry(),

                    // OilGroup
                    // Comment
                    // ContainerType
                    // BaggagesAlert
                    // FlightAlert                                      
                    // HistoryObjectAssign
                    // FlightActivationHistory
                    // MobileDeviceActivationHistory
                    // HierarchicalLog                   
                    // DayTemplate
                    // DayTemplateGroup

                    entityDescriptors["Alert"].getMenuEntry(),
                    entityDescriptors["Unit"].getMenuEntry(),
                ]
            }
        ];

        const administrationMenu = [
            userEntityDescriptor.getMenuEntry(),
            roleEntityDescriptor.getMenuEntry(),
            roleToUserEntityDescriptor.getMenuEntry(),
            auditEntityDescriptor.getMenuEntry(),
            settingsEntityDescriptor.getMenuEntry(),
            fileBrowserPageMenuEntry()
        ];
        const reportMenu: any[] = [];

        const visualisationMenu = [
            chartEntityDescriptor.getMenuEntry(),
            dashboardEntityDescriptor.getMenuEntry(),
        ]

        if (AppMetaTempGlobals.appMetaInstance.hasPermission(Utils.pipeJoin([ENT_TABLE, dashboardEntityDescriptor.name]), false, data.currentPermissions)) {
            this.helperAppContainer.dispatchers.loadMenuEntries(dashboardEntityDescriptor.name).then(success => {
                this.helperAppContainer.dispatchers.getState().menuEntries[dashboardEntityDescriptor.name]?.forEach((d: any) => {
                    visualisationMenu.push({ content: d.name, to: dashboardEntityDescriptor.getEntityEditorUrl(d.id) + '/dashboard', icon: d.icon, exact: true, color: d.color });
                });

            });
        }
        if (AppMetaTempGlobals.appMetaInstance.hasPermission(Utils.pipeJoin([ENT_TABLE, chartEntityDescriptor.name]), false, data.currentPermissions)) {
            this.helperAppContainer.dispatchers.loadMenuEntries(chartEntityDescriptor.name).then(success => {
                this.helperAppContainer.dispatchers.getState().menuEntries[chartEntityDescriptor.name]?.forEach((d: any) => {
                    reportMenu.push({ content: d.name, to: chartEntityDescriptor.getEntityEditorUrl(d.id) + '/chart', icon: d.icon, exact: true, color: d.color });
                });
            });
        }

        const advancedMenu = [
            {
                content: _msg("Menu.advanced.configuration"), icon: "setting", submenus: [
                    blocklyScriptEntityDescriptor.getMenuEntry(),
                    scheduledTaskEntityDescriptor.getMenuEntry(),
                ]
            },
            { content: _msg("Menu.visualisation"), icon: "eye", submenus: visualisationMenu }
        ];

        if (data.currentUser?.isAdmin) {
            advancedMenu.push({
                content: _msg("Menu.developers"), icon: "computer", submenus: [
                    {
                        content: <Checkbox color="white" checked={localStorage.getItem(MAP_CLUSTER_MODE_KEY) === CLUSTER_MODE.PRUNE_CLUSTER} label={_msg("MapRealTime.prunecluster")}
                            onClick={() => {
                                let newValue = localStorage.getItem(MAP_CLUSTER_MODE_KEY) === CLUSTER_MODE.PRUNE_CLUSTER ? CLUSTER_MODE.CLASSIC_CLUSTER : CLUSTER_MODE.PRUNE_CLUSTER;
                                localStorage.setItem(MAP_CLUSTER_MODE_KEY, newValue);
                                window.location.reload();
                            }} />, to: "/"
                    },
                    { content: infoScanBaggageFormPage.sliceName, to: "/" + infoScanBaggageFormPage.sliceName, icon: "suitcase" },
                    { content: infoTemplateConnectedComponent.sliceName, to: "/" + infoTemplateConnectedComponent.sliceName, icon: "pencil" },
                    inventoryHistoryDataEntityDescriptor.getMenuEntry(),
                    {
                        as: "div", children: <>
                            {_msg("Menu.old")} &nbsp;
                            <NavLink to="/HumanResourceForm">HR form</NavLink> | &nbsp;
                        </>
                    },
                    assignTasksToResourcePageMenuEntry(),
                    missionEventValidationPageMenuEntry(),
                    ganttAssignmentFromFilesOnDiskPageMenuEntry(),
                    zeroTrainingIndexPageMenuEntry(),
                    bluetoothDevicesPageMenuEntry(),
                    realTimeGanttPageMenuEntry(),
                ],
            });
        }

        const menuEntries = [];
        // if AppMeta will add Home as initial menu entry, "Frequently used" will have itemId = 1, so 2, 3 and 4 are reserved for FMS, OMS and Pooling
        if (this.hasHomePageMenuEntry()) {
            this.menuInitialExpandedIds = { "2": true, "3": true, "4": true };
        } else {
            this.menuInitialExpandedIds = { "1": true, "2": true, "3": true };
        }
        menuEntries.push({ content: _msg("Menu.frequentlyUsed"), icon: "file alternate", submenus: frequentyUsedMenu });
        menuEntries.push({ content: _msg("Menu.FMS"), icon: "file alternate", submenus: fmsMenu });
        menuEntries.push({ content: _msg("Menu.OMS"), icon: "file alternate", submenus: omsMenu });
        menuEntries.push({ content: _msg("Menu.Pooling"), icon: "file alternate", submenus: poolingMenu });
        menuEntries.push({ content: _msg("Menu.referenceData"), icon: "file alternate", submenus: referencedDataMenu });
        menuEntries.push({ content: _msg("Menu.administration"), icon: "settings", submenus: administrationMenu });
        menuEntries.push({ content: _msg("Menu.report"), icon: "file alternate", submenus: reportMenu });
        menuEntries.push({ content: _msg("Menu.advanced"), icon: "computer", submenus: advancedMenu });
        menuEntries.push({
            content: _msg("Menu.support"), icon: "help circle", submenus: [
                // { content: <a href={mailto}>{_msg("Menu.ticket")}</a>, as: "div", to: ".", icon: "file alternate outline" }
            ]
        });

        return menuEntries;
    }

    enableModalRoutes() {
        return true;
    }

    protected getFieldsForOrg() {
        return super.getFieldsForOrg() + " airport { id }"
    }

    getOrganizationTreeIcon(itemId: string, object: any, currentOrg: Optional<Organization>, iconProps?: any, getDefaultOrgIconForParents?: boolean) {
        if (object.children?.length === 0) {
            if (object.airport) {
                return entityDescriptors["Airport"].getIcon(iconProps);
            }
        }
        return super.getOrganizationTreeIcon(itemId, object, currentOrg, iconProps, getDefaultOrgIconForParents);
    }

    protected renderAdditionalUserInfo(user: User): React.ReactNode {
        // on initializationsForClient will come as an ER object, if will be updated will come just with identifier
        const er = (this.helperAppContainer.dispatchers.getState().appContainerContextValue.initializationsForClient as XopsInitializationsForClient).currentHumanResource?.vehicle;
        if (!Utils.isNullOrEmpty(er) && !Utils.isNullOrEmpty(er.identifier)) {
            return <span className="no-wrap-no-overflow-ellipsis"><Icon name='truck' className="AppContainer_menu_icon_without_label" /> {er.identifier}</span>
        }
        super.renderAdditionalUserInfo(user);
    }

    getVersionInfo(version: string): React.ReactNode {
        const mobileVersion = XopsMobileWrapper.getMobileVersion();
        if (mobileVersion) {
            return <>{super.getVersionInfo(version)}<span>{mobileVersion}</span></>;
        }
        return super.getVersionInfo(version);
    }

    protected addCustomFieldsToEntityDescriptors() {
        super.addCustomFieldsToEntityDescriptors();
        //preparing data for dropdown - customFields from Settings
        entityDescriptors["TelemetryEventMapping"].getField("mappingTo").customize();
    }

    async afterLogin() {
        await super.afterLogin();
        w.xopsMobileWrapperAfterLogin();
    }

    async beforeLogout() {
        w.xopsMobileWrapperBeforeLogout();
        super.beforeLogout();
    }

    createLogoutParams() {
        return { ...super.createLogoutParams(), ...{ data: XopsMobileWrapper.getMobileDeviceInfo() } };
    }

    public goBack() {
        (XopsMobileWrapper.isDeviceMobileApp() || XopsMobileWrapper.isDeviceWindowsApp()) && (this.helperAppContainer.dispatchers.getState().appContainerContextValue.initializationsForClient as XopsInitializationsForClient).currentHumanResource &&
            (AppMetaTempGlobals.history.location.pathname === "/"
                || AppMetaTempGlobals.history.location.pathname === "/" + XOPS_MOBILE_PATH
                || AppMetaTempGlobals.history.location.pathname === "/" + XOPS_MOBILE_MISSIONS_PATH)
            ? AppMetaTempGlobals.history.push("/" + XOPS_MOBILE_PATH) // if mobile && HR login, redirect to mobile path
            : super.goBack();
    }

    public getAdditionalUserMenuEntries(): any[] {
        let entries = super.getAdditionalUserMenuEntries();
        const { userMenuSettings } = (this.helperAppContainer.dispatchers.getState().appContainerContextValue.initializationsForClient as XopsInitializationsForClient);
        if ((this.helperAppContainer.dispatchers.getState().appContainerContextValue.initializationsForClient as XopsInitializationsForClient).currentHumanResource &&
            userMenuSettings.showChangeEquipment
        ) {
            entries.push({
                key: 'changeEquipmentResource', text: _msg("humanResource.changeEquipment"), icon: 'truck', onClick: () => {
                    w.XopsUtils.showChangeEr(null);
                }
            });
        }

        return entries;
    }

    public getAdditionalUserHeaderEntries(): any[] {
        let entries = super.getAdditionalUserHeaderEntries();
        if ((this.helperAppContainer.dispatchers.getState().appContainerContextValue.initializationsForClient as XopsInitializationsForClient).currentHumanResource) {
            entries.push({
                key: 'mobileDevice', text: <span>{XopsMobileWrapper.getMobileDeviceInfo().mobileDeviceIdentifier}</span>, icon: mobileDeviceEntityDescriptor.icon,
                disabled: true
            });
        }

        return entries;
    }

    protected async initRRCSingletons() {
        await XopsColorRegistry.INSTANCE.init();
        super.initRRCSingletons();
    }

    protected renderRRCSingletons() {
        return <>
            <XopsColorRegistryRRC id={RRC_SINGLETON} />
            {super.renderRRCSingletons()}
        </>;
    }
}


export const xopsHomePageWrappedComponent = class extends HomePage {

    protected backgroundImageURL() {
        if (XopsMobileWrapper.isDeviceMobileApp() || XopsMobileWrapper.isDeviceWindowsApp()) {
            return undefined;
        }
        return super.backgroundImageURL();
    }

    renderUnderJumbotron() {

        return (
            <>
                <p>&nbsp;</p>
                <Card.Group itemsPerRow='4' centered>
                    <Card>
                        <Card.Content>
                            <Card.Header><Icon name="map outline" />{_msg("Menu.map")}</Card.Header>
                            <Menu vertical fluid items={[
                                historicalMapAnalysisEntityDescriptor.getMenuEntry(),
                                positionEntityDescriptor.getMenuEntry(),
                                drivingEventEntityDescriptor.getMenuEntry(),
                                checklistEntityDescriptor.getMenuEntry(),
                                qualificationEntityDescriptor.getMenuEntry(),
                                detectionEventEntityDescriptor.getMenuEntry(),
                            ]}>
                            </Menu>
                        </Card.Content>
                    </Card>
                    <>
                        {AppMetaTempGlobals.appMetaInstance.hasPermission(Utils.pipeJoin([ENT_TABLE, dashboardEntityDescriptor.name])) ?
                            <Card>
                                <Card.Content>
                                    <Card.Header><Icon name="chart pie" />{_msg("Dashboard.label.plural")}</Card.Header>
                                    <Menu vertical fluid>
                                        {AppContainer.INSTANCE.props.menuEntries[dashboardEntityDescriptor.name]?.map((d: MenuEntry) => {
                                            return <Menu.Item key={d.id} content={d.name} icon={<Icon name={d.icon as any} style={{ color: d.color }} />} link={true} onClick={() => this.props.dispatchers.dispatch(push(dashboardEntityDescriptor.getEntityEditorUrl(d.id) + "/dashboard"))} />
                                        })}
                                        <Menu.Item content={_msg("Dashboard.menu.viewAll")} icon={<Icon name='ellipsis horizontal' color='grey' />} link={true}
                                            onClick={() => this.props.dispatchers.dispatch(push(dashboardEntityDescriptor.getEntityTableUrl()))} />
                                    </Menu>
                                </Card.Content>
                            </Card>
                            : null}
                        {AppMetaTempGlobals.appMetaInstance.hasPermission(Utils.pipeJoin([ENT_TABLE, chartEntityDescriptor.name])) ?
                            <Card>
                                <Card.Content>
                                    <Card.Header><Icon name="chart pie" />{_msg("Chart.label.plural")}</Card.Header>
                                    <Menu vertical fluid>
                                        {AppContainer.INSTANCE.props.menuEntries[chartEntityDescriptor.name]?.map((c: MenuEntry) => {
                                            return <Menu.Item key={c.id} content={c.name} icon={<Icon name={c.icon as any} style={{ color: c.color }} />} link={true} onClick={() => this.props.dispatchers.dispatch(push(chartEntityDescriptor.getEntityEditorUrl(c.id) + "/chart"))} />
                                        })}
                                        <Menu.Item content={_msg("Dashboard.menu.viewAll")} icon={<Icon name='ellipsis horizontal' color='grey' />} link={true}
                                            onClick={() => this.props.dispatchers.dispatch(push(chartEntityDescriptor.getEntityTableUrl()))} />
                                    </Menu>
                                </Card.Content>
                            </Card>
                            : null}
                    </>
                    <Card>
                        <Card.Content>
                            <Card.Header><Icon name="eye" />{_msg("Menu.datareferences")}</Card.Header>
                            <Menu vertical fluid items={[
                                equipmentResourceEntityDescriptor.getMenuEntry(),
                                humanResourceEntityDescriptor.getMenuEntry(),
                                organizationEntityDescriptor.getMenuEntry(),
                                territoryEntityDescriptor.getMenuEntry(),
                                entityDescriptors["EquipmentModel"].getMenuEntry(),
                                entityDescriptors["EquipmentType"].getMenuEntry(),
                                AppMetaTempGlobals.appMetaInstance.hasPermission(Utils.pipeJoin([ENT_READ, ganttAssignmentEntityDescriptor.name])) ? <Menu.Item key="lastGanttAssignment" content={_msg("GanttAssignment.lastGanttAssignment")} link={true} permission={Utils.pipeJoin([ENT_READ, ganttAssignmentEntityDescriptor.name])}
                                    onClick={async () => {
                                        const lastGanttAssignment = await (ganttAssignmentEntityDescriptor as GanttAssignmentEntityDescriptor).getLastGanttAssignment();
                                        if (lastGanttAssignment) {
                                            return this.props.dispatchers.dispatch(push(ganttAssignmentEntityDescriptor.getEntityEditorUrl(lastGanttAssignment.id) + "/gantt"))
                                        }
                                        return this.props.dispatchers.dispatch(push(ganttAssignmentEntityDescriptor.getEntityTableUrl()))
                                    }}
                                /> : null
                            ]}>
                            </Menu>
                        </Card.Content>
                        <Card.Content>
                            <Card.Header><Icon name="help circle" />{_msg("Menu.support")}</Card.Header>
                            <Menu vertical fluid items={[
                                {
                                    key: "ticket", icon: "file alternate outline", as: "div", content:
                                        <a href={mailto}>{_msg("Menu.ticket")}</a>

                                },
                                // { as: NavLink, ...zeroTrainingIndexPageMenuEntry() as any, className: !allow ? "disabledItem" : undefined }
                            ]}>
                            </Menu>
                        </Card.Content>
                    </Card>
                </Card.Group>

                {/* <Segment compact style={{width: '80%', margin: 'auto', marginTop: '10px', padding: '0'}}>
                <Header as='h3' attached='top'><Icon name='dashboard' />{_msg("Dashboard.label.plural")}</Header>
                <Segment secondary attached='bottom'>     
                    <Grid centered stretched columns='4'><Grid.Row>
                        {this.props.dashboardLinks.map((d: any, index: number) => {
                            return <Grid.Column width='4'><Card link onClick={() => this.props.dispatchers.dispatch(push('/DashboardEditor/' + d.id + '/dashboard'))}>
                                <Card.Header className={'dashboardLink' + index} style={{padding: '10px', textAlign: 'center'}}>
                                    <div><style>{`
                                        .${'dashboardLink' + index} i.inverted.bordered.icon, i.inverted.circular.icon {
                                            background-color: ${d.color} !important;
                                        }
                                        `}
                                        </style>
                                            <Icon size='huge' circular bordered inverted name={d.icon} />
                                            <Header as='h3' style={{ color: d.color }}>{d.name}</Header></div>
                                    </Card.Header>
                                </Card></Grid.Column>
                            })}
                            <Grid.Column width='4'><Card link onClick={() => this.props.dispatchers.dispatch(push('/DashboardTable'))}>
                                <Card.Header style={{ padding: '10px', textAlign: 'center' }}>
                                    <Icon size='huge' style={{ margin: '0 auto' }} circular bordered color='grey' name='ellipsis horizontal' />
                                    <Header as='h3' color='grey'>{_msg("Dashboard.menu.viewAll")}</Header>
                                </Card.Header>
                            </Card></Grid.Column>
                        })}
                        <Grid.Column width='4'><Card link onClick={() => this.props.dispatchers.dispatch(push('/DashboardTable'))}>
                        <Card.Header style={{padding: '10px', textAlign: 'center'}}>
                            <Icon size='huge' style={{margin: '0 auto'}} circular bordered color='grey' name='ellipsis horizontal'/>
                            <Header as='h3' color='grey'>{_msg("Dashboard.menu.viewAll")}</Header>
                        </Card.Header>
                        </Card></Grid.Column>
                    </Grid.Row></Grid>
                </Segment></Segment> */}
            </>);
    }

};

infoLoginPage.wrappedComponentClass = XopsLoginPage;
infoHomePage.wrappedComponentClass = xopsHomePageWrappedComponent;

export function createMeta(): XopsAppMeta {
    const appMeta = new XopsAppMeta([]);
    appMeta.addConnectedPageInfos([infoPasswordResetInitPage, infoPasswordResetFinishPage,
        infoTemplateConnectedComponent, infoScanBaggageFormPage,
    ]);
    appMeta.addConnectedPageInfos([infoLoginPage]);
    appMeta.addConnectedPageInfos([infoHomePage, infoPersonalHomePage]);

    // appMeta.zeroTrainingArticlesRegistry.addFromModule(chartHistogramCountInTerritoriesZt);
    // appMeta.zeroTrainingArticlesRegistry.addFromModule(chartPieDistanceTimeInTerritoriesZt);
    // appMeta.zeroTrainingArticlesRegistry.addFromModule(chartBarsDistanceTimeInTerritoriesZt);
    // appMeta.zeroTrainingArticlesRegistry.addFromModule(chartPieCountByCriteriaZt);
    // TODO CC: temporary commented; we need to fix map stories before!
    // appMeta.zeroTrainingArticlesRegistry.addFromModule(historicalMapEquipment);
    // appMeta.zeroTrainingArticlesRegistry.addFromModule(historicalMapAnalysis);
    // appMeta.zeroTrainingArticlesRegistry.addFromModule(customQueryZt);
    appMeta.zeroTrainingArticlesRegistry.addFromModule(dashboardZt);
    appMeta.zeroTrainingArticlesRegistry.addFromModule(roleZt);

    return appMeta;
}

export const appMeta: XopsAppMeta = createMeta();

export default appMeta.getAppComponent();

// It was added here because dashboard widget editor doesn't see it
export const REAL_TIME_MAP_WIDGET = "realTimeMapWidget";
export const MAP_WIDGET = "mapWidget";
export const VEHICLE_INFORMATION_WIDGET = "vehicleInformationWidget";
export const DIAGNOSTIC_TROUBLE_CODE_WIDGET = "diagnosticTroubleCodeWidget";

DashboardWidgetFactories.INSTANCE.widgets[REAL_TIME_MAP_WIDGET] = new class extends DashboardWidgetFactory {
    allowMultiple = false;
    public componentClass = RealTimeMapWidget;

    getEntityDescriptor(widgetConfig: any): EntityDescriptor {
        return DashboardWidgetEntityDescriptor("MapRealTime")
            .addFieldDescriptor({ name: "filter", type: FieldType.filter, mode: EntityFilterMode.OBJECT, optional: true })
            .addFieldDescriptor({ name: "airport", type: "Airport", optional: true })
    }
    renderEditor(id: string, widgetConfig: any, dashboardTabRef: RefObject<DashboardTab>) {
        return this.renderEditorInternal(id, widgetConfig, dashboardTabRef, { ...widgetConfig, ...{ id: id } });
    }
    renderWidget(id: string, widgetProps: WidgetProps, dashboardTabRef: RefObject<DashboardTab>) {
        return super.renderWidget(id, {
            ...widgetProps,
            rootFilter: (widgetProps.widgetConfig as any).filter,
            airport: (widgetProps.widgetConfig as any).airport,
            entityTypes: [equipmentResourceEntityDescriptor.name],
            mapId: id,
            showGoToTableButton: true,
            layers: { [equipmentResourceEntityDescriptor.name]: { layerType: MARKER_TYPE } }
        } as any, dashboardTabRef);
    }
    getWizardInfo() {
        return { title: _msg("MapRealTime"), description: _msg("MapRealTime.content"), image: 'images/realtime-map.png' }
    }
}();

DashboardWidgetFactories.INSTANCE.widgets[MAP_WIDGET] = new class extends DashboardWidgetFactory {
    type = DashboardWidgetType.ENTITY;
    allowMultiple = false;
    componentClass = MapWidgetRRC;
    getEntityDescriptor(widgetConfig: any): EntityDescriptor {
        return DashboardWidgetEntityDescriptor("Map");
    }
    renderEditor(id: string, widgetConfig: any, dashboardTabRef: RefObject<DashboardTab>) {
        return this.renderEditorInternal(id, widgetConfig, dashboardTabRef, { ...widgetConfig, ...{ id: id } });
    }
    renderWidget(id: string, widgetProps: WidgetProps, dashboardTabRef: RefObject<DashboardTab>) {
        return super.renderWidget(id, {
            ...widgetProps,
            entityTypes: [equipmentResourceEntityDescriptor.name],
            layer: { [equipmentResourceEntityDescriptor.name]: { layerType: MARKER_TYPE } }
        } as any,
            dashboardTabRef);
    }
    getWizardInfo() {
        return { title: _msg("Map"), description: _msg("MapWidget.content"), image: 'images/realtime-map.png' }
    }
}();

DashboardWidgetFactories.INSTANCE.widgets[VEHICLE_INFORMATION_WIDGET] = new class extends DashboardWidgetFactory {
    type = DashboardWidgetType.ENTITY;
    componentClass = VehicleInformationWidget;
    getEntityDescriptor(widgetConfig: any, dashboardEntity: any): EntityDescriptor {
        return DashboardWidgetEntityDescriptor("FieldWidget")
            .addFieldDescriptor({ name: "title", type: FieldType.string, optional: true })
            .addFieldDescriptor({ name: "entityName", type: FieldType.entityName, initialValue: dashboardEntity.entityName, enabled: false })
    }
    getWizardInfo() {
        return { title: 'Vehicle Information Widget', description: 'Displays a information section common for multiple types of equipments.', component: VehicleInformationWidget, testState: { entity: { odometer: 2412.543, batteryLevel: "78" } } }
    };
}

DashboardWidgetFactories.INSTANCE.widgets[DIAGNOSTIC_TROUBLE_CODE_WIDGET] = new class extends DashboardWidgetFactory {
    type = DashboardWidgetType.ENTITY;
    entityType = "EquipmentResource";
    componentClass = DiagnosticTroubleCodeWidgetRRC;
    getEntityDescriptor(widgetConfig: any, dashboardEntity: any): EntityDescriptor {
        return DashboardWidgetEntityDescriptor(DIAGNOSTIC_TROUBLE_CODE_WIDGET).addFieldDescriptor({ name: "title", type: FieldType.string, optional: true });
    }
    getWizardInfo() {
        return { title: 'Diagnostic Trouble Code (DTC) Widget', description: 'Displays DTC (errors) for the equipment.', component: DiagnosticTroubleCodeWidgetRRC, testState: { id: "DiagnosticTroubleCodeWidget", status: WidgetStatus.DONE, entities: [{ name: "Handbrake Fault", code: "62" }, { name: "SRO", code: "57" }], totalCount: 2 } };
    };
};

HistoryGraphItemFactory.INSTANCE.addItemForEntityType(equipmentResourceEntityDescriptor, HistoryGraphMapItemRRC as any);
HistoryGraphItemFactory.INSTANCE.addItemForEntityType(missionEntityDescriptor, HistoryGraphMissionGanttItemRRC as any);

searchOptions["EquipmentResource"] = ["identifier", "plateNumber"];
searchOptions["Address"] = ["name"];
searchOptions["Territory"] = ["name"];

export function isFlexMode() {
    return window.localStorage.getItem("flexMode") === "true";
}

export function isIframe() {
    return window !== window.parent;
}

contextMenuActions.push(EditAction);
contextMenuActions.push(DeleteAction);
contextMenuActions.push(OpenClosedAndOverdueMissions);
contextMenuActions.push(CreateMissionAction);
contextMenuActions.push(CreateTaskAction);

(async function init() {
    await ReportDescriptorMaterializers.INSTANCE.getReportDescriptorsForServer();
})();
